// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__QzcE6","mainContent":"LandingPage_mainContent__GHbIx","laptopImage":"LandingPage_laptopImage__t2aCZ"};